import { getContentTextFields } from '@eliadmin/core/src/api/content-fields/content-text-mapping';
import type { ContentFieldsOwner } from '@eliadmin/core/src/api/content-fields/content-fields-types';

export function getProductContentTexts(owner: ContentFieldsOwner | null | undefined) {
  return getContentTextFields(
    owner,
    [2].map(groupId => ({ groupId, component: 'same-name-text' as const, itemIndex: 0 })),
  );
}
